import gql from 'graphql-tag';

export const createOrUpdateEditorialHighlight = gql`
	mutation createOrUpdateEditorialHighlight($editorialHighlight: EditorialHighlightInput!) {
		createOrUpdateEditorialHighlight(editorialHighlight: $editorialHighlight) {
			id
		}
	}
`;
